import type { PIconProps } from "@porsche-design-system/components-react"
import type { VehicleHistoryEventType } from "@slfinrtl/ui-bff-routes"

export const eventTypeIconMap: Record<VehicleHistoryEventType, PIconProps["name"]> = {
	ConfiguratorImagesChanged: "image",
	Image360UrlChanged: "image",
	RealImagesChanged: "image",
	VehicleAddedToInventory: "plus",
	VehicleArrivedAtDealership: "pin",
	VehicleChanged: "edit",
	VehicleConfigurationFixed: "lock",
	VehicleDealershipChanged: "switch",
	VehicleDelivered: "truck",
	VehicleDeliveryRevoked: "truck",
	VehicleOrderChanged: "list",
	VehiclePricingChanged: "price-tag",
	VehicleProduced: "home",
	VehiclePvmsOrderChanged: "list",
	VehicleRemoved: "delete",
	VehicleReservationCancelled: "calendar",
	VehicleReservationChanged: "calendar",
	VehicleReserved: "calendar",
	VehicleSaleCancelled: "purchase",
	VehicleSaleChanged: "purchase",
	VehicleSold: "purchase",
	VehicleTransferred: "switch",
	VehicleUsageCancelled: "road",
	VehicleUsageEnded: "road",
	VehicleUsageStarted: "road",
	VehicleVinAdded: "plus",
	VideoChanged: "video",
}
